<template>
    <div class="qksm qksm14">
        <h4>十四、国有资产占用情况说明</h4>
        <div class="nogap">
            <p>
                截至2021年12月31日，本{{$parent.typeText}}共有车辆{{T14.共有车辆}}辆，
                其中：
                <span v-for="(item,index) in T14.carlist">
                    {{item.name}}{{item.value}}辆{{index == T14.carlist.length - 1 ? '；':'、'}}
                </span>
                单价50万元（含）以上的通用设备{{T14.五十万元}}台（套），
                单价100万元（含）以上的专用设备{{T14.一百万元}}台（套）。
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm14",
        props: {
            T14: {
                type: Object,
                default: "",
            },
        },
        data() {
            return {
                qksm: this.$store.state.divData.qksm,
                isPdf: this.$parent.isPdf
            }
        },
        created() {
            this.inspect()
        },
        updated: function () {
            this.inspect()
        },
        methods: {
            inspect() {
                var arr = Object.values(this.T14.carlist)
                var sum = 0;
                for (var i = 0; i < arr.length; i++) {
                    sum = sum + this.num(arr[i].value)
                }
                if (this.num(this.T14.共有车辆).toFixed(2) != this.num(sum).toFixed(2)) {
                    this.addOrSet("qksm14", "请检查本页《十四、国有资产占用情况说》，各项车辆使用情况总和应该等于部门共有车辆总数。");
                } else {
                    this.remove("qksm14")
                }
            }
        },
        components: {
            reason,
        },
    };
</script>
